export const FORECAST_CHANGE_TYPE = {
    SYSTEM: "SYSTEM",
    MANUAL: "MANUAL",
};
export const PUBLISH_TAB = {
    SYSTEM: "system",
    MANUAL: "manual",
};
//# sourceMappingURL=publish.js.map